import { Grid } from '@mui/material';
import { obfuscatePhoneNumber } from '@nx-smartmonkey/shared/helpers';
import { RoutalSelect, RoutalSelectMultiSelectOption, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BackArrow } from '../../../assets/svg/onboarding/icons/BackArrow';
import * as routes from '../../../constants/Routing';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { AuthBody, AuthBodyFooter } from '../Auth.styled';
import { TwoFactorMethod } from './context/reducer';
import { useAuthStatus } from './hooks/useAuthStatus';

export const TwoFactorSelector = () => {
  const { twoFactorMethods, onSetAuthStep, userIntent } = useAuthStatus();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [twoFactorMethod, setTwoFactorMethod] = useState<TwoFactorMethod>(twoFactorMethods[0] ?? null);

  const intlIdTranslations = {
    email: `auth.login.2fa.email`,
    sms: `auth.login.2fa.sms`,
  };

  useEffect(() => {
    if (twoFactorMethods.length === 1) {
      onSetAuthStep({ authStep: twoFactorMethods[0] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [twoFactorMethods]);

  if (twoFactorMethods.length === 0) {
    const redirectTo = searchParams.get(`redirectTo`);
    if ((redirectTo ?? ``) !== ``) {
      // TODO: Control if URL is from highway??
      navigate(redirectTo as string);
    } else {
      navigate(routes.PRIVATE_HIGHWAY);
    }
    return null;
  }

  const setMethod = () => {
    onSetAuthStep({ authStep: twoFactorMethod });
  };

  return (
    <>
      <AuthBody container direction="column" justifyContent="center">
        <Grid>
          <Text variant="h4" intlId="auth.login.2fa.title" style={{ marginBottom: `20px` }} />
        </Grid>

        <Grid>
          <RoutalSelect
            id="select-twoFactor"
            popoverProps={{
              options: twoFactorMethods.map(
                (option: TwoFactorMethod): RoutalSelectMultiSelectOption => ({
                  key: `twoFactor-method-${option}`,
                  content: <Text intlId={intlIdTranslations[option]} style={{ cursor: `pointer` }} />,
                  onClick: () => {
                    setTwoFactorMethod(option);
                  },
                })
              ),
            }}
          >
            <Text
              style={{ width: `100%`, cursor: `pointer`, textAlign: `start` }}
              intlId={intlIdTranslations[twoFactorMethod]}
            />
          </RoutalSelect>
        </Grid>

        <VSpacer small />

        <Grid>
          {twoFactorMethod === `email` && (
            <Text variant="body" intlId="auth.login.2fa.emailDescription" intlValues={{ email: userIntent.email }} />
          )}
          {twoFactorMethod === `sms` && (
            <Text
              variant="body"
              intlId="auth.login.2fa.smsDescription"
              intlValues={{ phone: obfuscatePhoneNumber(userIntent.phone!) }}
            />
          )}
        </Grid>

        <VSpacer medium />

        <Grid>
          <Button onClick={setMethod} intlId="auth.login.2fa.continue" />
        </Grid>
      </AuthBody>

      <VSpacer medium />

      <AuthBodyFooter item container justifyContent="center">
        <Grid
          item
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          style={{ cursor: `pointer`, padding: `5px` }}
          onClick={() => {
            onSetAuthStep({ authStep: `login` });
          }}
        >
          <BackArrow
            style={{
              cursor: `pointer`,
              strokeWidth: `1.3px`,
            }}
          />
          <Text
            isBold
            style={{
              fontSize: `13px`,
              marginLeft: `4px`,
            }}
            variant="button"
            intlId="back"
          />
        </Grid>
      </AuthBodyFooter>
    </>
  );
};
